(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-cro-treatment"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-pdp-cro-treatment]:not([data-pdp-cro-ready])';

    const selectedSize = (scope) => {
      const selectors = Array.from(scope.querySelectorAll('.single-option-selector[data-index]'));
      const sizeSelector = selectors.find((item) => {
        const name = String(item.dataset.optionName || '').trim().toLowerCase();
        return name.includes('velič') || name.includes('size');
      }) || (selectors.length === 1 ? selectors[0] : null);
      if (sizeSelector) return String(sizeSelector.value || '').trim();
      return String(scope.querySelector('.swatch-element:not(.color) input:checked')?.value || '').trim();
    };

    const publish = (eventName, payload) => {
      const detail = {
        experiment_id: 'pdp_post_cta_cro_v2',
        locale: document.documentElement.lang || '',
        market_host: window.location.host,
        ...payload
      };

      if (!Array.isArray(window.dataLayer)) window.dataLayer = [];
      window.dataLayer.push({ event: eventName, ...detail });
      document.dispatchEvent(new CustomEvent(`drfuss:${eventName}`, { detail }));

      const analytics = window.Shopify?.analytics;
      if (analytics && typeof analytics.publish === 'function') {
        const result = analytics.publish(`drfuss:${eventName}`, detail);
        if (result && typeof result.catch === 'function') result.catch(() => {});
      }
    };

    const init = (root) => {
      root.dataset.pdpCroReady = 'true';
      const productSection = root.closest('[data-section-type="product"]') || document;
      const meta = productSection.querySelector('.product-single__meta');
      const discovery = root.querySelector('[data-pdp-color-discovery]');
      let stickyTracked = false;

      const localizePackSelector = (attempt = 0) => {
        const packRoot = productSection.querySelector('[data-socks-pdp-pack-selector]');
        const controller = packRoot?.__socksPdpPackSelector;
        if (!controller?.config) {
          if (attempt < 40) window.setTimeout(() => localizePackSelector(attempt + 1), 50);
          return;
        }

        controller.config.strings = {
          ...(controller.config.strings || {}),
          save: root.dataset.packSave || 'Save [amount]',
          pairsTwoFour: root.dataset.packPairsTwoFour || 'pairs',
          pairsOther: root.dataset.packPairsOther || 'pairs',
          mixAria: root.dataset.packMixAria || '',
          mixTitle: root.dataset.packMixTitle || '',
          mixBadge: root.dataset.packMixBadge || '',
          mixComposition: root.dataset.packMixComposition || '',
          mixSize: root.dataset.packMixSize || ''
        };
        controller.decorateCards();
        controller.sync(false);
        root.dataset.packLocalizationReady = 'true';
      };

      localizePackSelector();

      discovery?.addEventListener('click', () => {
        publish('pdp_color_discovery_click', {
          placement: 'after_payment_options',
          product_handle: root.dataset.currentHandle || '',
          selected_size: selectedSize(productSection)
        });
      });

      if (!meta) return;

      const syncStickyState = () => {
        const active = meta.classList.contains('enabled_mobile_sticky_btns');
        document.documentElement.classList.toggle('pdp-cro-sticky-active', active);
        if (active && !stickyTracked) {
          stickyTracked = true;
          publish('pdp_sticky_cta_view', {
            placement: 'mobile_bottom',
            product_handle: root.dataset.currentHandle || '',
            selected_size: selectedSize(productSection)
          });
        }
      };

      syncStickyState();
      new MutationObserver(syncStickyState).observe(meta, { attributes: true, attributeFilter: ['class'] });
    };

    const initAll = (scope = document) => scope.querySelectorAll(selector).forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
